<template>
    <div>
        <form id="formResumo" @submit.prevent="submit()">

            <table>
                <tbody>
                    <tr>
                        <td><i class="fas fa-user"></i></td>
                        <td>Você vai emitir uma cobrança para <b>
                                <cliente :cliente_id="cliente_id" :show_only="['name']" @setCliente="setCliente" />
                                <b></b>
                            </b></td>
                    </tr>
                    <tr v-if="servico.vendas.length > 1">
                        <td><i class="far fa-calendar"></i></td>
                        <td>em <b>{{ servico.vezes }} parcela(s) fixa(s)</b> com intervalo <b>Mensal</b></td>
                    </tr>
                    <tr>
                        <td><i class="far fa-money-bill-alt"></i></td>
                        <td>no valor de <b>{{
                            parseFloat(servico.total).toLocaleString('pt-br', {
                                style:
                                    'currency', currency: 'BRL'
                            })
                        }}<b></b></b></td>
                    </tr>
                    <tr v-if="servico.vendas.length == 1">
                        <td><i class="fas fa-calendar"></i></td>
                        <td>com vencimento em <b>{{ moment(servico.vendas[0].vencimento).format("DD/MM/YYYY") }}</b>
                        </td>
                    </tr>
                    <tr v-else>
                        <td><i class="fas fa-calendar"></i></td>
                        <td>com entrada de <b>{{
                            parseFloat(servico.entrada).toLocaleString('pt-br', {
                                style:
                                    'currency', currency: 'BRL'
                            })
                        }}</b> em <b>{{ moment(servico.vendas[0].vencimento).format("DD/MM/YYYY") }}</b>
                            e o vencimento da primeira parcela em <b>{{
                                moment(servico.vendas[1].vencimento).format("DD/MM/YYYY")
                            }}</b>
                        </td>
                    </tr>

                </tbody>
            </table>

            <div v-if="servico.vendas.length > 1">
                <h4>Resumo do Parcelamento</h4>
                <p>Caso queira modificar algum valor, clique no valor de uma das parcelas</p>
                <table class="table">
                    <thead>
                        <tr>
                            <th width="10%">Parcela</th>
                            <th width="50%">Valor</th>
                            <th>Vencimento</th>
                            <th>Parcela</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(parcela, index) in parcelas" :key="parcela.id">
                            <td width="10%">{{ parcela.key }}</td>

                            <td width="50%">
                                <div v-if="current_edit != index" @click.prevent="edit(index)">{{
                                    parseFloat(parcela.valor).toLocaleString('pt-br', {
                                        style:
                                            'currency', currency: 'BRL'
                                    })
                                }} </div>
                                <div class="d-flex align-items-center" v-else>
                                    <money v-model.number="parcela.valor" class="form-control" name="entrada"></money>
                                    <b-button variant="success" v-b-tooltip.hover title="Recalcular parcelas"
                                        @click.prevent="recalculateParcelas(index)">
                                        <span class="d-flex align-items-center"> <i class="fas fa-calculator mr-2"></i>
                                            <small>Recalcular</small></span>
                                    </b-button>
                                </div>
                            </td>
                            <td>{{ moment(parcela.vencimento).format("DD/MM/YYYY") }}</td>
                            <td>PARCELA {{ parcela.key }} de {{ parcelas.length }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="4">Total das parcelas: {{
                                this.vendas.reduce((total, obj) => total + obj.valor,
                                    0).toLocaleString('pt-br', {
                                        style:
                                            'currency', currency: 'BRL'
                                    })
                            }}
                            </td>
                        </tr>
                    </tfoot>
                </table>

            </div>
        </form>

        <modal id="ConfirmarEmail" size="md" title="Confirmação do email do cliente">
            <div>
                <i class="fas fa-envelope mr-2"></i>
                <h3> O email <b>{{ cliente.email }}</b> está correto para receber a notificação de cobrança?</h3>
            </div>
            <b-form-group label="" v-slot="{ ariaDescribedby }">
                <b-form-radio v-model="confirm_email" :aria-describedby="ariaDescribedby" name="some-radios"
                    value="yes">SIM</b-form-radio>
                <b-form-radio v-model="confirm_email" :aria-describedby="ariaDescribedby" name="some-radios"
                    value="no">NÂO</b-form-radio>
            </b-form-group>

            <div class="form-group" v-if="confirm_email == 'no'">
                <label>Informe o email correto do cliente</label>
                <input v-model="new_email" type="email" class="form-control" />
            </div>


            <b-button variant="primary" @click.prevent="submit()"><i class="fas fa-paper-plane"></i> Enviar</b-button>

        </modal>

    </div>

</template>
<script>
import { isNumber } from 'lodash';

export default {

    props: {
        cliente_id: Number,
        servico: Object,
    },


    watch: {
        confirm_email(val) {
            if (val == 'yes'){
                this.new_email = null;
                this.continue = true;
            }
        },
        current_edit(newVal, oldVal){
            if(isNumber(oldVal) && newVal == null){
              this.current_edit = oldVal;
              this.recalculateParcelas(oldVal);
            }
        }
    },


    data() {
        return {
            confirm_email: null,
            new_email: null,
            cliente: {
                email: null,

            },
            continue: false,
            current_edit: null,
            subtotal: [],
            vendas: [],
        }
    },
    computed: {

        parcelas() {

            this.vendas = [];
            this.subtotal = [];

            const vendas = this.servico.vendas.filter((item) => item.key != 0);

            if (vendas.length > 0) {
                for (let i = 0; i < parseInt(this.servico.vezes); i++) {

                    vendas[i].valor = (parseFloat(this.servico.total) - parseFloat(this.servico.entrada)) / parseInt(this.servico.vezes)

                    this.vendas.push(vendas[i]);

                    this.subtotal.push(
                        {
                            valor: 0
                        }
                    )

                }
            }
            return this.vendas;
        },
    },
    methods: {
        edit(index) {
            this.current_edit = null;
            if (index != parseInt(this.servico.vezes) - 1)
                this.current_edit = index;
        },
        setCliente(cliente) {
            this.cliente = cliente
        },
        recalculateParcelas(index) {

            this.continue = true;

            if (this.vendas[index].valor >= parseFloat(this.servico.total) - parseFloat(this.servico.entrada)) {
                this.$swal({ title: 'O valor informado não pode ser maior ou igual ao (total - entrada), ', icon: 'warning' });
                this.continue = false;
                return false;
            }

            //ADIOCIONA OS VALORES ANTERIORES NO SUBTOTAL
            for (let i = index; i >= 0; i--) {

                if (i != index) {
                    this.subtotal[i].valor = this.vendas[i].valor
                }

            }

            //DEFINE O TOTAL DA PARCELA ATUAL E ZERA O SUBTOTAL DEPOIS DELA
            for (let i = index; i < parseInt(this.servico.vezes); i++) {
                if (i == index) {
                    if (!this.minValue(this.vendas[index].valor)) {
                        return false;
                    }
                    this.subtotal[index].valor = this.vendas[index].valor
                } else {
                    this.subtotal[i].valor = 0;
                }
            }


            //RECALCULA OS PROXIMOS DEPOIS DO ATUAL
            for (let i = index; i < parseInt(this.servico.vezes); i++) {

                if (i != index) {

                    let valor = ((parseFloat(this.servico.total) - parseFloat(this.servico.entrada)) - this.subtotal.reduce((n, { valor }) => n + valor, 0)) / this.subtotal.filter(item => item.valor == 0).length
                    if (!this.minValue(valor)) {
                        return false;
                    }

                    this.vendas[i].valor = valor
                }
            }
            this.current_edit = null;

        },
        minValue(valor) {
            if (valor <= 5) {
                this.$swal({ title: 'O valor de cada parcela deve ser maior que R$5', icon: 'warning' });
                this.continue = false;
                return false;
            }

            return true;

        },
        validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        async submit() {

            if (!this.confirm_email) {
                this.$swal({ title: 'Escolha uma das opções', icon: 'warning' });

                return false;
            }

            if (this.confirm_email == 'no' && !this.validateEmail(this.new_email)) {
                this.$swal({ title: 'Informe um email válido', icon: 'warning' });

                return false;
            }else{
                this.continue = true;
            }

            if (this.vendas.reduce((total, obj) => total + obj.valor,
                0) != parseFloat(this.servico.total) - parseFloat(this.servico.entrada) && parseFloat(this.servico.entrada) != 0) {
                this.$swal({ title: 'Edite novamente o valor de uma das parcelas para recalcular', icon: 'warning' });

                return false;
            }



            if (this.continue) {

                await this.$api.put(`gerarBoleto/${this.servico.id}`, {
                    new_email: this.new_email,
                    parcelas: this.vendas
                });


                this.$root.$emit("reloadServicos");
                this.$bvModal.hide("ConfirmarEmail");
                this.$bvModal.hide("OrdemServicoTabs");
            }
        }
    },

}
</script>
